
import Vue from "vue";
import AppCreateUblArchiveModalWrapper from "./CreatePdfArchiveModalWrapper.vue";
import { PdfArchiveService } from "@/services/pdf-archive-service";
import { PdfS3UploadedFile } from "@/models/pdf-archive-file";
import AppSendMessageDialog from "@/components/mail/SendMessageDialog.vue";
import { downloadBlob } from "@/utils/blob";

export default Vue.extend({
	data(){
		return {
			sendMailDialogOpened: false,
			downloadedFile: null as null | File,
			downloadingFile: false
		};
	},
	props: {
		createdArchive: {
			type: Object as ()=>PdfS3UploadedFile,
			required: true
		}
	},
	computed: {
		publicLink():string{
			return this.createdArchive.getPublicLink();
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async download(){
			await this.storeFileInMemory();
			if (!this.downloadedFile) return;
			downloadBlob(this.downloadedFile, this.downloadedFile.name);
		},
		copyLink(){
			let vueInput = this.$refs.input as any;
			if (!vueInput) return;
			let input = vueInput.inputElement as HTMLInputElement;
			input.select();
			document.execCommand("copy");
			this.$wf.notify(this.$ct("coppied"), "success", 3000, "check");
		},
		async storeFileInMemory(){
			if (this.downloadedFile) return;
			if (this.downloadingFile) return;
			try{
				this.downloadingFile = true;
				this.downloadedFile = await PdfArchiveService.downloadArchiveToFile(this.createdArchive);
			}catch(err){
			}finally{
				this.downloadingFile = false;
			}
		},
		async openSendMailDialog(){
			await this.storeFileInMemory();
			if (!this.downloadedFile) return;
			this.sendMailDialogOpened = true;
		}
	},
	components: {
		AppCreateUblArchiveModalWrapper,
		AppSendMessageDialog
	},
	i18nEx: {
		componentPrefix: "components.pdf-archive"
	}
});
